<div mat-dialog-title class="modal-header">
  <div class="d-flex justify-content-between">
    <span>Checklist Details</span>
    <button type="button" class="close close-btn" mat-dialog-close><i class="fa fa-close fa-md"></i></button>
  </div>
</div>
<mat-dialog-content style="overflow: hidden !important;">
  <div class="checkList-Container">
    <div class="row">
      <form [formGroup]="checkListForm">
        <div class="checkList-Details-Container ml-4 mr-4" *ngIf="this.checkListItems.controls.length>0">
          <table id="viewChecklistTable" class="table card-layout table-striped table mt-0">
            <thead>
              <tr>
                <td class="header_td table_heading">
                  <div class="header_container text-primary">
                    <div class="header_title col-lg-2">S.NO.</div>
                    <div class="header_title col-lg-3">Item</div>
                    <div class="header_title col-lg-3">Last Updated By</div>
                    <div class="header_title col-lg-3">Last Updated On</div>
                    <div class="header_title col-lg-1 justify-content-center">Completed</div>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr formArrayName="checkListItems"
                *ngFor="let control of this.checkListItems.controls; let index = index;">
                <td [formGroupName]="index">
                  <div class="row_container">
                    <div class="title_container col-lg-2">
                      <div class="row_title">S.NO.</div>
                      <div class="row_detail" style="word-break: break-word;">
                        <span>
                          {{ index+1 }}
                        </span>
                      </div>
                    </div>
                    <div class="title_container col-lg-3">
                      <div class="row_title">Item</div>
                      <div class="row_detail">
                        <span class="pl-0">
                          {{ this.checkListItems.controls[index].value.itemName }}
                        </span>
                      </div>
                    </div>
                    <div class="title_container col-lg-3">
                      <div class="row_title">Last Updated By</div>
                      <div class="row_detail">
                        <span class="pl-0">
                          {{ this.checkListItems.controls[index].value.itemValues.lastUpdatedByName }}
                        </span>
                      </div>
                    </div>
                    <div class="title_container col-lg-3">
                      <div class="row_title">Last Updated On</div>
                      <div class="row_detail">
                        <span class="pl-0">
                          {{ this.checkListItems.controls[index].value.itemValues.lastUpdatedOn | date : "MM:dd:yy
                          hh:mm"}}
                        </span>
                      </div>
                    </div>
                    <div class="title_container  col-lg-1">
                      <div class="row_title">Completed</div>
                      <div class="row_detail" style="word-break: break-word;">
                        <span class="mr-2 pr-3" formGroupName="itemValues">
                          <input type="checkbox" formControlName="isChecked" (change)="onCheckBoxValueChenge(index)"
                            [checked]="this.checkListItems.controls[index].value.itemValues.isChecked">
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
      <div *ngIf="this.checkListItems.controls.length == 0" class="ml-4 text-danger">No Record Found</div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="check-list-footer">
  <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
    *ngIf="this.checkListItems.controls.length>0 && (this.user.role=='Coordinator' || this.user.role === 'Management' || this.user.role=='Executive Admin')"
    (click)="updateCheckListItems()">Save Changes</button>
  <button class="flat-butt flat-danger-butt flat-danger-grad-butt" mat-dialog-close type="button">Cancel</button>
</mat-dialog-actions>